module.exports = __webpack_public_path__ + "static/altavista-2333ec373b2599a1fd0859a9422f032b.jpg";